import { useTranslations } from "next-intl";
import Modal from "@components/core/Modal";
import Button from "@components/core/Button";
import Link from "@components/core/Link";

function UnsubscribeModalTryAnotherCloset({ opened, close }) {
  const t = useTranslations("accounts");

  return (
    <Modal
      show={opened}
      onHide={close}
      title={t("unsubscribe_modal.try_another_closet.header")}
      fullscreen="sm-down"
    >
      <div className="p-3">
        <div className="pt-3 p-sm-3 text-center h-100 d-flex flex-column justify-content-between">
          <div className="mb-4">
            <h3 className="mb-5 mx-auto" style={{ maxWidth: "380px" }}>
              {t("unsubscribe_modal.try_another_closet.title")}
            </h3>
            <p className="mb-5">
              {t.rich("unsubscribe_modal.try_another_closet.argument1", {
                span: (chunks) => <span className="font-weight-bold">{chunks}</span>,
              })}
            </p>
            <p className="mb-5">
              {t("unsubscribe_modal.try_another_closet.argument2")}
            </p>
          </div>

          <div>
            <Link href="/catalogue">
              <Button>
                {t("unsubscribe_modal.try_another_closet.stay")}
              </Button>
            </Link>

            <div className="py-3">
              <Link
                href={t('unsubscribe_modal.try_another_closet.leave_link')}
                className="link-primary no-underline font-size-sm"
              >
                {t("unsubscribe_modal.try_another_closet.leave")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default UnsubscribeModalTryAnotherCloset;
